import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Configure dayjs to use timezone plugins
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Formats a date in the America/Toronto timezone (Eastern Time - EST/EDT).
 * 
 * This function converts the input date to the Eastern timezone and formats it
 * according to the specified format string. If no format is provided, it defaults
 * to "MMM D, YYYY" which matches the browser's toLocaleDateString output for
 * { month: "short", day: "numeric", year: "numeric" }.
 * 
 * @param {string | Date} date - The date to format (ISO string, Date object, or date string)
 * @param {string} [format="MMM D, YYYY"] - The dayjs format string to use for output
 * @returns {string} The formatted date string in Eastern Time
 * 
 * @example
 * ```typescript
 * // Returns "Feb 17, 2026" (in Eastern Time)
 * formatDateInEasternTime("2026-02-17T12:00:00Z")
 * 
 * // Returns "02/17/2026" (in Eastern Time)
 * formatDateInEasternTime("2026-02-17T12:00:00Z", "MM/DD/YYYY")
 * 
 * // Returns "February 17, 2026" (in Eastern Time)
 * formatDateInEasternTime("2026-02-17T12:00:00Z", "MMMM D, YYYY")
 * ```
 */
export function formatDateInEasternTime(
  date: string | Date,
  format = "MMM D, YYYY"
): string {
  return dayjs(date).tz("America/Toronto").format(format);
}
